export default "__VITE_ASSET__0TPKYR1h__"